export default __webpack_public_path__ + "static/bg-contact-d9006b6ad8ae5489cacebb2c9be79118.jpg";